import React, { useMemo } from 'react';
import { injectIntl } from '../../../Utils/reactIntlCompat';
import PropTypes from 'prop-types';
import PagesStepper from '../../../Components/PagesStepper';

const CustomNewPracticeActions = function CustomNewPracticeActions({
  intl,
  currentPage = 0,
  handleChangePage = () => {},
  max = 1,
  edit = false,
}) {
  const nextText = useMemo(() => {
    if (currentPage === max - 1) {
      return edit ? intl.messages.EDIT : intl.messages.INSERT;
    }
    return null;
  });
  return (
    <PagesStepper
      variant="progress"
      currentStep={currentPage}
      handleChangeStep={handleChangePage}
      submitStep={currentPage === max - 1}
      nextText={nextText}
      backText={currentPage === 0 ? intl.messages.CANCEL : null}
      max={max}
    />
  );
};

CustomNewPracticeActions.propTypes = {
  intl: PropTypes.object.isRequired,
  currentPage: PropTypes.number,
  handleChangePage: PropTypes.func,
  max: PropTypes.number,
  edit: PropTypes.bool,
};

export default injectIntl(CustomNewPracticeActions);
